import React from 'react';
import { MessageSquare, Search, Inbox } from 'lucide-react';

export function EmptyState({ type = 'messages' }) {
  const configs = {
    messages: {
      icon: Inbox,
      title: 'No messages yet',
      description: 'Messages will appear here once customers reach out.',
    },
    search: {
      icon: Search,
      title: 'No results found',
      description: 'Try adjusting your search or filter criteria.',
    },
    categories: {
      icon: MessageSquare,
      title: 'No categories yet',
      description: 'Categories will be generated as messages arrive.',
    },
  };

  const config = configs[type] || configs.messages;
  const Icon = config.icon;

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">{config.title}</h3>
      <p className="text-sm text-muted-foreground">{config.description}</p>
    </div>
  );
}